import { getApiUrl } from '../config/api.config.jsx';

class PartnerOnboardingAPI {
  constructor() {
    this.baseURL = `${getApiUrl()}/partner`;
  }

  authHeaders() {
    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token && String(token).trim()) {
      headers.Authorization = `Bearer ${String(token).trim()}`;
    }
    return headers;
  }

  async getOnboardingStatus(userId) {
    try {
      const response = await fetch(`${this.baseURL}/onboarding?userId=${userId}`, {
        headers: this.authHeaders(),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching onboarding status:', error);
      throw error;
    }
  }

  async updateStep(userId, stepId, stepData, currentStep) {
    try {
      const response = await fetch(`${this.baseURL}/onboarding/step/${stepId}?userId=${userId}`, {
        method: 'PUT',
        headers: this.authHeaders(),
        body: JSON.stringify({ stepData, currentStep })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating step:', error);
      throw error;
    }
  }

  async uploadFile(userId, stepId, fileName, s3Key) {
    try {
      const response = await fetch(`${this.baseURL}/onboarding/upload?userId=${userId}`, {
        method: 'POST',
        headers: this.authHeaders(),
        body: JSON.stringify({ stepId, fileName, s3Key })
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }

  async getFiles(userId, stepId = null) {
    try {
      const url = stepId 
        ? `${this.baseURL}/onboarding/files?userId=${userId}&stepId=${stepId}`
        : `${this.baseURL}/onboarding/files?userId=${userId}`;
      
      const response = await fetch(url, { headers: this.authHeaders() });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching files:', error);
      throw error;
    }
  }
}

export default PartnerOnboardingAPI;
